/**
 * Shared styling tokens and constants for the long-form article landers
 * (/potty/potty-training, /sleep/sleep-training).
 *
 * Kept in one place so the two articles can't drift apart typographically.
 */

/** Section heading inside an article body. */
export const ARTICLE_H2 =
  "mt-10 mb-4 text-[1.375rem] font-bold leading-snug tracking-tight text-text-strong sm:text-[1.625rem]";

/** Body-copy wrapper — vertical rhythm + reading size for a run of paragraphs. */
export const ARTICLE_PROSE =
  "space-y-5 text-[17px] leading-[1.75] text-foreground/90";

/** Where every CTA on the article landers points. */
export const ARTICLE_CTA_HREF = "/report";

export const ARTICLE_PATHS = [
  "/potty/potty-training",
  "/sleep/sleep-training",
] as const;

export const isArticlePath = (pathname: string) =>
  (ARTICLE_PATHS as readonly string[]).includes(pathname);
